module.exports = ".descriptionn{\n    margin-left: 135px;\n}\n.sticky2{\n    position: sticky;\n    top: 0px;\n    background-color: #000000;\n    z-index: 1000;\n}\n@media screen and (max-width: 1024px) {\n    .btns{\n        margin: 0 10px 10px;\n    }\n    .descriptionn {\n        margin-left: 0px;\n    }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/albums/album-detail/album-detail.component.css
// module id = ./src/app/albums/album-detail/album-detail.component.css
// module chunks = main